var _style, _g, _desc, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.2,43.7c5.5,0,11,0,16.4,0c5.4,0,10.7,0,16.1,0H48c2.1,0,3.9-0.6,5.4-2c0.1-0.1,0.3-0.3,0.4-0.4 c3.3-3.5,2.7-9-1.5-11.6c-1.4-0.9-2.9-1.7-4.3-2.4c-6.1-3-12.5-4.6-19.3-4.7c-4.5-0.1-9-0.1-13.4-0.1h-0.1c-1,0-1.2,0.2-1.2,1.2 v17.6v1.1C13.9,43.5,14.1,43.7,15.2,43.7z M40.9,26.3c3.8,0.9,11.2,4.7,12.1,6.3c-0.1,0-0.2,0-0.3,0c-2.4,0-4.7,0-7.1,0 C42.4,32.5,40.1,29.4,40.9,26.3z M15.5,24.1c0.2,0,0.4,0,0.5,0c4.6,0,9.2,0,13.8,0.1c3.1,0.1,6.2,0.7,9.3,1.5 c0.1,0,0.2,0.1,0.3,0.1c-0.3,1.1-0.3,2.3,0,3.4c0.8,2.9,3.3,4.9,6.4,4.9c2.6,0,5.1,0,7.7,0c0.5,0,0.6,0.2,0.7,0.6 c0.2,0.9,0.2,1.8,0,2.8H15.5v-3.4h0.7c5.2,0,10.5,0,15.7,0c1,0,2-0.3,2.5-1.3c0.2-0.4,0.3-0.8,0.3-1.2c0-1,0-2,0-3 c0-1.2-0.9-2.2-2.2-2.4c-0.3,0-0.6,0-0.8,0c-5.2,0-10.3,0-15.5,0h-0.7V24.1z M15.5,32.5v-4.6h4.8v4.6H15.5z M22,32.5v-4.6h4.8v4.6 H22z M28.4,32.5v-4.6c0.7,0,1.4,0,2.1,0c0.6,0,1.2,0,1.8,0c0.7,0,0.9,0.3,0.9,1c0,0.9,0,1.8,0,2.7c0,0.5-0.2,0.9-0.8,0.9 C31.1,32.5,29.8,32.5,28.4,32.5z M15.5,39.2h37.9c-0.1,0.2-0.1,0.3-0.2,0.4c-0.6,0.8-1.2,1.3-1.9,1.8c-0.9,0.5-1.9,0.8-3.1,0.8 c-10.8,0-21.5,0-32.3,0c-0.1,0-0.2,0-0.4,0v-0.8V39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.9,46.3c-0.1,0-0.2,0-0.2,0c-13.2,0-26.3,0-39.5,0c-0.9,0-1.3,0.2-1.3,0.8c0,0.5,0.4,0.8,1.2,0.8 c6.6,0,13.2,0,19.8,0c6.6,0,13.3,0,19.9,0c0.7,0,1-0.3,1-0.8C55.9,46.6,55.5,46.4,54.9,46.3z"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "other - services") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(17.000000, 11.016480)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.694777, 0.913268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportation);
export default __webpack_public_path__ + "static/media/transportation.3561d68c.svg";
export { ForwardRef as ReactComponent };